import { useAPIAction, BlanksDraftApi } from "melco-shared-logic";

export const useDuplicateBlank = (blankId: string) => {
  return useAPIAction(
    BlanksDraftApi,
    async (api) => {
      const data = await api.userBlankDuplicateDraft({
        id: blankId,
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    { translationPrefix: "blanks.actions.duplicate" }
  );
};
